<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Increment Letter Report</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-autocomplete
            v-model="selectedYear"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Year"
            :items="years"
            clearable
            hide-selected
            :error-messages="errors.collect('selectedYear')"
            data-vv-name="selectedYear"  
            data-vv-as="year"
          />
          <v-autocomplete
            v-model="selectedCompanies"
            v-validate="'required'"
            :loading="dropdownLoading"
            label="Companies"
            item-text="name"
            item-value="id"
            :items="companies"
            clearable
            multiple
            hide-selected 
            chips
            small-chips
            deletable-chips
            :error-messages="errors.collect('selectedCompanies')"
            data-vv-name="selectedCompanies"  
            data-vv-as="companies"
          />
          <v-col class="mt-2">
            <span> Merge all in one files? </span>
            <v-radio-group
              v-model="isMerged"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
          <v-col class="mt-2">
            <span> Sort by employees' name? </span>
            <v-radio-group
              v-model="isSortByEmployeeName"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              /> 
            </v-radio-group>
          </v-col>
        </v-col>
  
        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="loading" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>
      
          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                color="primary"
                :loading="loading"
                @click="submitForm"
              >
                generate
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        loading: false,
        companies: [],
        selectedCompanies: [],
        dropdownLoading: false,
        progressbar: 0,
        isMerged: 0,
        isSortByEmployeeName: 0,
        selectedYear: '',
        years: [],
      }
    },
    created () {
      this.dropdownLoading = true

      this.$api.hrisCompanies().list()
        .then(res => {
          this.companies = _.orderBy(res.data, ['name'], ['asc'])

          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.dropdownLoading = false
        })

      this.$api.payrollPeriods().list('?year=distinct')
        .then(res => {
          this.years = res.data
        })
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.payrollELetters().incrementLetter(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            })
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/zip' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Increment Letters - ' + this.selectedYear + '.zip') 
                link.click()
                this.loading = false
                this.progressbar = 0

                this.$snack({ message: 'Increment letters downloaded successfully' })
              })
              .catch(error => {
                this.loading = false
                if (error.response.status === 400) {
                  this.$snack({ 
                    color: 'error',
                    message: 'No record found', 
                  })
                }
              })
          })
      },

      prepareFormData () {
        return {
          isMerged: this.isMerged,
          isSortByEmployeeName: this.isSortByEmployeeName,
          year: this.selectedYear,
          companies: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies }
      },
    },
  }
</script>
